import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, t as toPathString, c as serializeDataIfNeeded, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ImportExportApi - axios parameter creator
 * @export
 */
const ImportExportApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {File} [importFile]
         * @param {ImportMode} [mode] Whether an import upload adds the listed associations or removes them. Same Excel schema is used for both; the mode is chosen per upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import: async (importFile, mode, options = {}) => {
            const localVarPath = `/v1/ImportExport/Import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }
            if (importFile !== undefined) {
                localVarFormParams.append('importFile', importFile);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary An empty import template (header row only) for a handler-owned worksheet. (Auth roles: System)
         * @param {string} [sheet]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTemplate: async (sheet, options = {}) => {
            const localVarPath = `/v1/ImportExport/DownloadTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (sheet !== undefined) {
                localVarQueryParameter['sheet'] = sheet;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {IEDownloadToken} [IEDownloadToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCustomers: async (IEDownloadToken, options = {}) => {
            const localVarPath = `/v1/ImportExport/ExportCustomers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(IEDownloadToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {IEDownloadToken} [IEDownloadToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrders: async (IEDownloadToken, options = {}) => {
            const localVarPath = `/v1/ImportExport/ExportOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(IEDownloadToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileActions: async (options = {}) => {
            const localVarPath = `/v1/ImportExport/GetFileActions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileErrors: async (id, options = {}) => {
            const localVarPath = `/v1/ImportExport/GetFileErrors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Worksheets owned by an BizWeb.NC.API.Services.IImportSheetHandler, with the columns their template expects. (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportHandlerSheets: async (options = {}) => {
            const localVarPath = `/v1/ImportExport/GetImportHandlerSheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {IEDownloadToken} [IEDownloadToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iEDownload: async (IEDownloadToken, options = {}) => {
            const localVarPath = `/v1/ImportExport/IEDownload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(IEDownloadToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {File} [importFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCustomers: async (importFile, options = {}) => {
            const localVarPath = `/v1/ImportExport/ImportCustomers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (importFile !== undefined) {
                localVarFormParams.append('importFile', importFile);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ImportExportApi - functional programming interface
 * @export
 */
const ImportExportApiFp = function (configuration) {
    const localVarAxiosParamCreator = ImportExportApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {File} [importFile]
         * @param {ImportMode} [mode] Whether an import upload adds the listed associations or removes them. Same Excel schema is used for both; the mode is chosen per upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _import(importFile, mode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator._import(importFile, mode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportExportApi._import']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary An empty import template (header row only) for a handler-owned worksheet. (Auth roles: System)
         * @param {string} [sheet]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadTemplate(sheet, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadTemplate(sheet, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportExportApi.downloadTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {IEDownloadToken} [IEDownloadToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportCustomers(IEDownloadToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportCustomers(IEDownloadToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportExportApi.exportCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {IEDownloadToken} [IEDownloadToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportOrders(IEDownloadToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportOrders(IEDownloadToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportExportApi.exportOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileActions(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileActions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportExportApi.getFileActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileErrors(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileErrors(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportExportApi.getFileErrors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Worksheets owned by an BizWeb.NC.API.Services.IImportSheetHandler, with the columns their template expects. (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImportHandlerSheets(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImportHandlerSheets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportExportApi.getImportHandlerSheets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {IEDownloadToken} [IEDownloadToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async iEDownload(IEDownloadToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.iEDownload(IEDownloadToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportExportApi.iEDownload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {File} [importFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importCustomers(importFile, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importCustomers(importFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImportExportApi.importCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ImportExportApi - factory interface
 * @export
 */
const ImportExportApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ImportExportApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {File} [importFile]
         * @param {ImportMode} [mode] Whether an import upload adds the listed associations or removes them. Same Excel schema is used for both; the mode is chosen per upload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(importFile, mode, options) {
            return localVarFp._import(importFile, mode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary An empty import template (header row only) for a handler-owned worksheet. (Auth roles: System)
         * @param {string} [sheet]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTemplate(sheet, options) {
            return localVarFp.downloadTemplate(sheet, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {IEDownloadToken} [IEDownloadToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCustomers(IEDownloadToken, options) {
            return localVarFp.exportCustomers(IEDownloadToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {IEDownloadToken} [IEDownloadToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrders(IEDownloadToken, options) {
            return localVarFp.exportOrders(IEDownloadToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileActions(options) {
            return localVarFp.getFileActions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileErrors(id, options) {
            return localVarFp.getFileErrors(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Worksheets owned by an BizWeb.NC.API.Services.IImportSheetHandler, with the columns their template expects. (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImportHandlerSheets(options) {
            return localVarFp.getImportHandlerSheets(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {IEDownloadToken} [IEDownloadToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        iEDownload(IEDownloadToken, options) {
            return localVarFp.iEDownload(IEDownloadToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {File} [importFile]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCustomers(importFile, options) {
            return localVarFp.importCustomers(importFile, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ImportExportApi - object-oriented interface
 * @export
 * @class ImportExportApi
 * @extends {BaseAPI}
 */
class ImportExportApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: System)
     * @param {File} [importFile]
     * @param {ImportMode} [mode] Whether an import upload adds the listed associations or removes them. Same Excel schema is used for both; the mode is chosen per upload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportExportApi
     */
    _import(importFile, mode, options) {
        return ImportExportApiFp(this.configuration)._import(importFile, mode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary An empty import template (header row only) for a handler-owned worksheet. (Auth roles: System)
     * @param {string} [sheet]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportExportApi
     */
    downloadTemplate(sheet, options) {
        return ImportExportApiFp(this.configuration).downloadTemplate(sheet, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {IEDownloadToken} [IEDownloadToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportExportApi
     */
    exportCustomers(IEDownloadToken, options) {
        return ImportExportApiFp(this.configuration).exportCustomers(IEDownloadToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {IEDownloadToken} [IEDownloadToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportExportApi
     */
    exportOrders(IEDownloadToken, options) {
        return ImportExportApiFp(this.configuration).exportOrders(IEDownloadToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportExportApi
     */
    getFileActions(options) {
        return ImportExportApiFp(this.configuration).getFileActions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportExportApi
     */
    getFileErrors(id, options) {
        return ImportExportApiFp(this.configuration).getFileErrors(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Worksheets owned by an BizWeb.NC.API.Services.IImportSheetHandler, with the columns their template expects. (Auth roles: System)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportExportApi
     */
    getImportHandlerSheets(options) {
        return ImportExportApiFp(this.configuration).getImportHandlerSheets(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {IEDownloadToken} [IEDownloadToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportExportApi
     */
    iEDownload(IEDownloadToken, options) {
        return ImportExportApiFp(this.configuration).iEDownload(IEDownloadToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {File} [importFile]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportExportApi
     */
    importCustomers(importFile, options) {
        return ImportExportApiFp(this.configuration).importCustomers(importFile, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ImportExportApi, ImportExportApiAxiosParamCreator, ImportExportApiFactory, ImportExportApiFp };
//# sourceMappingURL=import-export-api.js.map
